// Enumerations
import { AppErrorEnumeration } from 'enumerations/app-error.enumeration';
// Types
import { ErrorType } from 'providers/error/types/error.type';

const convertErrorToErrorEnum = (error: ErrorType['error']): AppErrorEnumeration =>
  error && Object.values(AppErrorEnumeration).includes(error as AppErrorEnumeration)
    ? (error as AppErrorEnumeration)
    : AppErrorEnumeration.UNKNOWN_ERROR;

export { convertErrorToErrorEnum };
